
import React from 'react';
import { AccountGroup } from '../data/chartData';
import { AccountListItem } from './AccountListItem';

interface AccountGroupSectionProps {
  group: AccountGroup;
}

export const AccountGroupSection = ({ group }: AccountGroupSectionProps) => {
  return (
    <div className="space-y-2">
      <h3 className="font-medium text-lg">{group.name}</h3>
      <div className="space-y-1">
        {group.accounts.map((account) => (
          <AccountListItem key={account.id} account={account} />
        ))}
      </div>
    </div>
  );
};
